import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useAuth } from './AuthContext';
import App from './App';
import { postLogin } from './apiService';
import { jwtDecode } from 'jwt-decode';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import Person4Icon from '@mui/icons-material/Person4';
import Logo from '../src/components/pages/Logo/AdithiLogo.png';
import PersonIcon from "@mui/icons-material/Person";
import { FaUser, FaLock, FaEye, FaEyeSlash } from "react-icons/fa";
import ScatterPlotIcon from '@mui/icons-material/ScatterPlot';
import CleanHandsOutlinedIcon from '@mui/icons-material/CleanHandsOutlined';

const LoginForm = () => {
    const history = useHistory();
    const { isAuthenticated, login } = useAuth();
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [loginFailed, setLoginFailed] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [isAnimating, setIsAnimating] = useState(false);
    // const [companyId, setCompanyId] = useState('');
    //const [branchId, setBranchId] = useState('');
    const location = useLocation();

    const branchId = 1;
    const companyId = 1;

    useEffect(() => {
        setIsAnimating(true);
    }, []);

    const handleLogin = async () => {
        try {

            const jwtToken = await performLogin();
            const responseData = jwtDecode(jwtToken);
            const keysToRemove = ['iss', 'exp', 'ttp', 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name', 'aud'];
            const permissions = Object.keys(responseData).filter(
                (key) => key !== 'companyId' && key !== 'userId' && !keysToRemove.includes(key)
            );

            let isSuper = false;
            if (responseData.isSuperAdmin.toLowerCase() === "true") {
                isSuper = true;
            }

            if (isSuper == false) {
                const parsedCompanyId = parseInt(responseData.companyId, 10);

                if (parsedCompanyId === companyId) {
                    login(responseData.companyId, responseData.branchId, responseData.userId, isSuper, responseData.superAdminCompanyId, responseData.CompanyName, permissions, jwtToken, responseData.roleName, responseData.branchstate, responseData.username);
                    const redirectParam = new URLSearchParams(location.search).get("redirect");
                    const redirectPath = redirectParam ? decodeURIComponent(redirectParam) : "/Home";
                    history.replace(redirectPath);
                }
                else {
                    toast.error('Invalid User !', {
                        position: "top-center",
                    });
                }
            }
            else {
                login(responseData.companyId, responseData.branchId, responseData.userId, isSuper, responseData.superAdminCompanyId, responseData.CompanyName, permissions, jwtToken, responseData.roleName, responseData.branchstate, responseData.username);
                const redirectParam = new URLSearchParams(location.search).get("redirect");
                const redirectPath = redirectParam ? decodeURIComponent(redirectParam) : "/Home";
                history.replace(redirectPath);
            }


        } catch (error) {
            toast.error('Login failed', {
                position: "top-center",
            });
        }
    };

    const performLogin = async () => {
        const loginData = {
            UserName: username,
            Password: password,
            CompanyId: companyId,
            BranchId: branchId
        };

        const response = await postLogin('LoginApi', loginData);

        if (response.responseCode === '1111') {
            const jwtToken = response.response_data.token;

            return jwtToken;
        } else {
            throw new Error(response.Message);
        }
    };

    if (isAuthenticated) {
        return <App />;
    }

    const bubbles = Array.from({ length: 20 }, (_, i) => {
        const size = 20 + Math.random() * 40; // bigger, like soap bubbles
        const duration = 8 + Math.random() * 8;
        const delay = Math.random() * 5;
        const left = Math.random() * 100;

        return (
            <div
                key={i}
                style={{
                    position: "absolute",
                    bottom: "-120px",
                    left: `${left}%`,
                    width: `${size}px`,
                    height: `${size}px`,
                    background:
                        "radial-gradient(circle at 30% 30%, rgba(255,255,255,0.8), rgba(255,255,255,0.2) 70%, transparent 100%)",
                    borderRadius: "50%",
                    backdropFilter: "blur(2px)",
                    animation: `floatUp ${duration}s linear infinite`,
                    animationDelay: `${delay}s`,
                }}
            />
        );
    });

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "100vh",
                background: "linear-gradient(135deg, #0f172a, #1e293b, #334155)",
                fontFamily: "Segoe UI, sans-serif",
            }}
        >
            {/* Glass-style login container */}
            <div
               style={{
                    width: "100%",
                    maxWidth: "420px",
                    padding: "40px",
                    borderRadius: "16px",
                    background: "rgba(255,255,255,0.08)",
                    backdropFilter: "blur(12px)",
                    border: "1px solid rgba(255,255,255,0.2)",
                    boxShadow: "0 8px 25px rgba(0,0,0,0.4)",
                    color: "#f1f5f9",
                }}
            >
                {/* ERP Logo / Brand */}
                <div style={{ textAlign: "center", marginBottom: "15px" }}>
                    <img
                        src={Logo}
                        alt="Adithi Fashion Logo"
                        style={{
                            width: "120px",
                            height: "auto",
                            marginBottom: "10px",
                            marginLeft:'90px'
                        }}
                    />
                </div>

                <h4
                    style={{
                        textAlign: "center",
                        marginBottom: "10px",
                        color: "#fff",
                        fontFamily: "Georgia, Cambria, 'Times New Roman', Times, serif",
                    }}
                >
                    <span
                        style={{
                            color: "#38bdf8",
                            fontFamily: "Georgia, Cambria, 'Times New Roman', Times, serif",
                        }}
                    >
                        ADITHI
                    </span>
                    <span
                        style={{
                            fontFamily: "Georgia, Cambria, 'Times New Roman', Times, serif",
                            marginLeft: "5px",
                        }}
                    >
                        FASHION
                    </span>
                </h4>

                <p
                    style={{
                        textAlign: "center",
                        marginBottom: "30px",
                        color: "#cbd5e1",
                    }}
                >
                    Sign in to continue
                </p>

                {/* Username */}
                <div style={{ position: "relative", marginBottom: "20px" }}>
                    <FaUser
                        style={{
                            position: "absolute",
                            top: "50%",
                            left: "12px",
                            transform: "translateY(-50%)",
                            color: "#94a3b8",
                        }}
                    />
                    <input
                        type="text"
                        placeholder="Username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        style={{
                            width: "100%",
                            padding: "12px 12px 12px 40px",
                            borderRadius: "8px",
                            border: "1px solid #475569",
                            background: "rgba(255,255,255,0.1)",
                            color: "#f8fafc",
                            outline: "none",
                            fontSize: "14px",
                        }}
                    />
                </div>

                {/* Password */}
                <div style={{ position: "relative", marginBottom: "20px" }}>
                    <FaLock
                        style={{
                            position: "absolute",
                            top: "50%",
                            left: "12px",
                            transform: "translateY(-50%)",
                            color: "#94a3b8",
                        }}
                    />
                    <input
                        type={showPassword ? "text" : "password"}
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        style={{
                            width: "100%",
                            padding: "12px 12px 12px 40px",
                            borderRadius: "8px",
                            border: "1px solid #475569",
                            background: "rgba(255,255,255,0.1)",
                            color: "#f8fafc",
                            outline: "none",
                            fontSize: "14px",
                        }}
                    />
                    <div
                        onClick={() => setShowPassword((prev) => !prev)}
                        style={{
                            position: "absolute",
                            top: "50%",
                            right: "12px",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                        }}
                    >
                        {showPassword ? (
                            <FaEyeSlash style={{ color: "#38bdf8" }} />
                        ) : (
                            <FaEye style={{ color: "#38bdf8" }} />
                        )}
                    </div>
                </div>

                {/* Login Button */}
                <button
                    onClick={handleLogin}
                    style={{
                        width: "100%",
                        padding: "12px",
                        borderRadius: "8px",
                        border: "none",
                        background: "linear-gradient(90deg, #38bdf8, #0ea5e9)",
                        color: "#fff",
                        fontWeight: "bold",
                        fontSize: "15px",
                        cursor: "pointer",
                        transition: "0.3s",
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.background =
                            "linear-gradient(90deg, #0ea5e9, #38bdf8)";
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.background =
                            "linear-gradient(90deg, #38bdf8, #0ea5e9)";
                    }}
                >
                    Login
                </button>
            </div>
        </div>
    );
}

export default LoginForm;
